/**
 * API DIFFERENCES vs ../checkbox.tsx (shadcn):
 * - State attr: data-checked/data-unchecked vs data-[state=checked]/data-[state=unchecked]
 * - Indicator: uses CheckIcon/MinusIcon vs lucide CheckIcon only
 * - Disabled attr: data-disabled vs disabled:* utilities
 *
 * Same API, different primitives
 */
'use client'

import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox'
import { cn } from '../lib/utils'
import { CheckIcon, MinusIcon } from './icon'

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        'checkbox focus-visible:ring-primary/80 focus-visible:ring-offset-surface-1 inline-flex outline-none focus-visible:ring-2 focus-visible:ring-offset-2 data-disabled:opacity-64 [@media(hover:none)]:data-disabled:pointer-events-none',
        // Per-option quiz feedback must outrank both the field-level
        // aria-invalid state and the checked state — declared last so
        // Tailwind's layer ordering (not selector specificity) decides.
        'data-[feedback=error]:border-error data-[feedback=success]:border-success data-[feedback=error]:data-checked:bg-error data-[feedback=success]:data-checked:bg-success',
        // Feedback is shown on a submitted, disabled field — keep it fully opaque.
        'data-[feedback]:data-disabled:opacity-100',
        className,
      )}
      data-slot="checkbox"
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className="checkbox-indicator"
        data-slot="checkbox-indicator"
        render={(props, state) => (
          <span {...props}>
            {state.indeterminate ? (
              <MinusIcon className="size-3.5" />
            ) : (
              <CheckIcon className="size-3.5" />
            )}
          </span>
        )}
      />
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
